import React, { useMemo } from 'react'
import { Popover, Row, Col } from 'antd'
import { renderTranslation, stopPropagation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { useAppSelector } from '../../../hooks'
import { setCapitalLetter } from '../../../Helpers/StringHelpers'
import { TableColumnTranslationPrefix } from '../../../Constants/Configuration'

function PriceListSizePopover(props) {
  const language = useAppSelector(state => state.present.language.value)

  const priceAndSizes = useMemo(() => {
    return props.priceAndSizes ?? []
  }, [props.priceAndSizes])

  const sizeListContent = useMemo(() => {
    return (
      <div>
        <table
          className='barcode-recap-table'
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <thead>
            <tr key={'barcode-recap-head-row'}>
              <th className='head-size'>
                {renderTranslation(language, TranslationKeys.tablePriceListSizePopoverSize)}
              </th>
              <th className='head-barcode'>
                {renderTranslation(
                  language,
                  TranslationKeys[TableColumnTranslationPrefix + setCapitalLetter(props.field)],
                )}{' '}
                {props.currencySymbol}
              </th>
            </tr>
          </thead>
          <tbody>
            {priceAndSizes.map((priceAndSize, index) => {
              return (
                <tr key={index}>
                  <td className='body-size'>{priceAndSize.size}</td>
                  <td className={'body-barcode'}>
                    {props.currencySymbol + ' '}
                    {priceAndSize[props.field]}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }, [language, priceAndSizes, props.currencySymbol, props.field])

  return (
    <Popover id='pricelist-sizes-popover' trigger={'click'} placement={'left'} content={sizeListContent}>
      <Row onClick={stopPropagation}>
        <Col flex='auto'>{props.children}</Col>
      </Row>
    </Popover>
  )
}

export default PriceListSizePopover
